import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Plus, Edit3, ArrowLeft } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { getToken } from "@/lib/api";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminBlogList = () => {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!getToken()) { nav("/admin/login"); return; }
    (async () => {
      try {
        const { data } = await axios.get(`${API}/admin/blog`, { headers: { Authorization: `Bearer ${getToken()}` } });
        setItems(data.items || []);
      } catch { setItems([]); }
      finally { setLoading(false); }
    })();
  }, [nav]);

  return (
    <div className="min-h-screen bg-midnight" data-testid="admin-blog-list">
      <Toaster theme="dark" position="top-right" />
      <header className="border-b border-gold/15 bg-midnight-deep/70 backdrop-blur-md sticky top-0 z-20">
        <div className="wrap py-4 flex items-center justify-between">
          <Link to="/admin" className="inline-flex items-center gap-2 text-ivory/70 hover:text-gold text-sm">
            <ArrowLeft className="h-4 w-4" /> Back to CMS
          </Link>
          <Link to="/admin/blog/new" className="btn-gold text-[10px]" data-testid="admin-new-post">
            <Plus className="h-4 w-4" /> New Post
          </Link>
        </div>
      </header>
      <main className="wrap py-10 max-w-5xl">
        <div className="eyebrow mb-3">Journal</div>
        <h1 className="font-display text-3xl text-ivory">Blog posts</h1>

        {loading && <div className="mt-8 text-ivory/55">Loading…</div>}
        {!loading && items.length === 0 && (
          <div className="mt-8 glass p-10 text-center text-ivory/60">
            No posts yet. Click <b>New Post</b> to write the first one.
          </div>
        )}
        <div className="mt-8 grid gap-3">
          {items.map((p) => (
            <Link key={p.id} to={`/admin/blog/${p.id}`} className="glass p-5 flex items-center justify-between gap-4 hover:border-gold/40 border border-transparent transition">
              <div className="min-w-0">
                <div className="flex items-center gap-3">
                  <span className={`text-[10px] uppercase tracking-[0.25em] ${p.status === "published" ? "text-gold" : "text-saffron"}`}>
                    {p.status}
                  </span>
                  <span className="text-[10px] uppercase tracking-[0.25em] text-ivory/40">
                    {p.publish_at ? new Date(p.publish_at).toLocaleDateString() : "no date"}
                  </span>
                </div>
                <div className="mt-1 font-display text-lg text-ivory truncate">{p.title || "(untitled)"}</div>
                <div className="text-xs text-ivory/50 truncate">/{p.slug}</div>
              </div>
              <Edit3 className="h-4 w-4 text-gold shrink-0" />
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
};

export default AdminBlogList;
